import React, { useEffect, useState, useMemo } from "react";
import { api } from "../../api";
import { motion } from "framer-motion";

export default function GameHistory() {
  const [history, setHistory] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchPhone, setSearchPhone] = useState("");

  const isSearching = searchPhone.trim().length > 0;

  // Fetch paginated game history
  const fetchGameHistory = async (pageNumber = 1, phone = "") => {
    try {
      const res = await api.get("/game-history", {
        params: { page: pageNumber, pageSize, phone },
      });

      const gamesArray = Array.isArray(res.data.games?.games)
        ? res.data.games.games
        : [];

      setHistory(gamesArray);
      setTotalPages(res.data.games?.totalPages || 1);
    } catch (err) {
      console.error("Error fetching game history:", err);
      setHistory([]);
      setTotalPages(1);
    }
  };

  useEffect(() => {
    fetchGameHistory(page, searchPhone);
  }, [page, searchPhone]);

  return (
    <motion.div
      className="bg-black/40 p-6 rounded-2xl shadow-lg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <h2 className="text-2xl font-semibold mb-4">Game History</h2>

      {/* 🔍 Phone Search */}
      <div className="mb-4 flex justify-end">
        <input
          type="text"
          placeholder="Search by winner phone..."
          value={searchPhone}
          onChange={(e) => setSearchPhone(e.target.value)}
          className="w-full md:w-1/4 px-4 py-2 rounded bg-black/60 border border-gray-600 text-white"
        />
      </div>

      <table className="w-full text-left">
        <thead>
          <tr className="border-b border-gray-600">
            <th className="p-2">Room ID</th>
            <th className="p-2">Winner Phone</th>
            <th className="p-2">Win Amount</th>
            <th className="p-2">Commission</th>
            <th className="p-2">Date</th>
          </tr>
        </thead>

        <tbody>
          {history.length === 0 ? (
            <tr>
              <td colSpan={5} className="text-center py-4 text-gray-400">
                No game history found.
              </td>
            </tr>
          ) : (
            history.map((h) => (
              <tr key={h.id} className="border-b border-gray-700">
                <td className="p-2">{h.roomId}</td>
                <td className="p-2">{h.winnerPhone}</td>
                <td className="p-2">{h.winAmount}</td>
                <td className="p-2">{h.gameCommission}</td>
                <td className="p-2">{h.createdAt?.split("T")[0]}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-between mt-4">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className="bg-blue-700 px-4 py-2 rounded disabled:opacity-50"
        >
          Previous
        </button>

        <span className="text-gray-300 px-2 py-2">
          {searchPhone
            ? `Search results • Page ${page} of ${totalPages}`
            : `Page ${page} of ${totalPages}`}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
          className="bg-blue-700 px-4 py-2 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </motion.div>
  );
}
